import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-checked-60px",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "dialog" };
import { useStore } from 'vuex';
import { computed } from 'vue';
// vuex
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportSuccess',
    setup(__props) {
        // libs
        const store = useStore();
        // actions
        const setIsModalExportSuccessVisible = (isVisible) => store.dispatch('engagementReport/setIsModalExportSuccessVisible', isVisible);
        // computed
        const getIsModalVisible = computed(() => store.getters['engagementReport/getIsModalExportSuccessVisible']);
        const closeModal = () => {
            setIsModalExportSuccessVisible(false);
        };
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: getIsModalVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((getIsModalVisible).value = $event)),
                id: "modal-export-success",
                "append-to-body": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("p", {
                            innerHTML: _ctx.$t('campaign.engagement-report.export-success')
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", {
                                class: "confirm btn",
                                onClick: closeModal
                            }, _toDisplayString(_ctx.$t('continue')), 1)
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
